type BoardSearchParams = {
    tab: string;
    page: string;
    category?: string;
};

export const createBoardSearchParams = (
    tab: string,
    page: number,
    category?: string
): BoardSearchParams => {
    const params: BoardSearchParams = {
        tab,
        page: String(page)
    };

    if(tab === 'CATEGORY' && category) {
        params.category = category;
    }

    return params;
};
